
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"svgviewer-output_33_","data-name":"svgviewer-output (33)","transform":"translate(.5 .5)","fill":"none","stroke":"#b3b3b3","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1","fill-rule":"evenodd"}},[_c('path',{attrs:{"id":"Path_28005","data-name":"Path 28005","d":"M10 3h2.341a1 1 0 01.919.606L16 10v4a2 2 0 01-2 2H2a2 2 0 01-2-2v-4l2.74-6.394A1 1 0 013.659 3H6"}}),_c('path',{attrs:{"id":"Path_28006","data-name":"Path 28006","d":"M11 6.086L8 9 5 6.086"}}),_c('path',{attrs:{"id":"Path_28007","data-name":"Path 28007","d":"M8 0v9"}}),_c('path',{attrs:{"id":"Path_28008","data-name":"Path 28008","d":"M0 10h4a1 1 0 011 1v1a1 1 0 001 1h4a1 1 0 001-1v-1a1 1 0 011-1h4"}})])])
          )
        }
      }
    